module.exports = __webpack_public_path__ + "img/hand-holding-droplet.13bd49ce.svg";